var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i-steps',{staticClass:"create-step",attrs:{"current":_vm.current}},[_c('i-step',{attrs:{"title":"上传必考题目"}}),_c('i-step',{attrs:{"title":"题库组题"}}),_c('i-step',{attrs:{"title":"生成试卷"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }